import moment from 'moment-timezone'
import UserModel from '@/_models/UserModel'
import { isCardOff, isGPSMode, isIndoorMode } from '@/_utils/card'

export const alertUserChangeLocation = (vm, newList: UserModel[], oldList: UserModel[]) => {
  if (!vm.refreshTimer || vm._isDestroyed || (!newList.length && !oldList.length)) {
    return
  }

  trackingUser(vm, newList, oldList)

  const filteredNewUsers = newList.filter(
    (item: any): boolean => {
      return !isCardOff(item) && (isGPSMode(item) || isIndoorMode(item))
    }
  )

  const filteredOldUsers = oldList.filter(
    (item: any): boolean => {
      return !isCardOff(item) && (isGPSMode(item) || isIndoorMode(item))
    }
  )

  const usersChanged: UserModel[] = []
  for (const oldUser of filteredOldUsers) {
    let isChanged = true
    for (const newUser of filteredNewUsers) {
      if (oldUser._id === newUser._id) {
        isChanged = (oldUser.nearest_beacon_id !== newUser.nearest_beacon_id) ||
          (oldUser.is_outside !== newUser.is_outside)
      }
    }

    if (isChanged) {
      usersChanged.push(oldUser)
    }
  }

  const showMessgaeChangeLocation = (msg) => {
    vm.$buefy.toast.open({
      duration: 5000,
      message: msg,
      position: 'is-bottom-right',
      queue: false,
    })
  }

  if (usersChanged.length) {
    for (const userChanged of usersChanged) {
      vm.$store.dispatch('users/getOne', userChanged._id).then((user: UserModel) => {
        if (vm.isGPSMode(user)) {
          showMessgaeChangeLocation(vm.$t('messages.user_just_go_out', { username: user.name }) as string)
        } else if (user.nearest_beacon_id) {
          if (userChanged.current_location_name) {
            showMessgaeChangeLocation(
              vm.$t('messages.user_just_goto_floor_x',
                {
                  username: user.name,
                  location: userChanged.current_location_name
                }
              ) as string)
          }
        }
      })
    }
  }
};

const trackingUser = (vm, newList: UserModel[], oldList: UserModel[]) => {
  if (!vm.trackingMode && !vm.trackingMode?.selectedTrackingUser?._id) {
    return
  }

  const newUserState = newList.find((user: UserModel) => user._id === vm.trackingMode.selectedTrackingUser._id)
  const oldUserState = oldList.find((user: UserModel) => user._id === vm.trackingMode.selectedTrackingUser._id)

  if (!oldUserState || !newUserState) {
    return
  }

  let userChangeState: any = {
    atTime: moment(newUserState?.measureded_at || new Date()).format('YYYY/MM/DD HH:mm:ss')
  }

  let haveChanged: boolean = false

  if (isChangedFloor(newUserState, oldUserState)) {
    haveChanged = true
    userChangeState = {
      ...userChangeState,
      fromFloorId: oldUserState.current_floor_id || 'Outside',
      toFloorId: newUserState.current_floor_id || 'Outside',
      currentLocationDevice: (newUserState.nearest_beacon_id || newUserState.nearest_card_id),
      device: newUserState.nearest_card_id ? 'card' : 'beacon',
      isChangeFloor: true
    }
  }
  else if (isChangedInFloor(newUserState, oldUserState)) {
    haveChanged = true
    userChangeState = {
      ...userChangeState,
      fromDeviceId: (oldUserState.nearest_beacon_id || oldUserState.nearest_card_id),
      fromDevice: oldUserState.nearest_card_id ? 'card' : 'beacon',
      toDeviceId: (newUserState.nearest_beacon_id || newUserState.nearest_card_id),
      toDevice: newUserState.nearest_card_id ? 'card' : 'beacon',
      floorId: newUserState.current_floor_id || 'Outside',
      isChangeFloor: false
    }
  }

  if (haveChanged) {
    vm.openPanelTracking(newUserState)
    vm.trackingMode.historyTracking.unshift(userChangeState)
  }
}

const isChangedInFloor = (newUserState: UserModel, oldUserState: UserModel) => {
  const isInSameFloor = newUserState.current_floor_id === oldUserState.current_floor_id
  const isChangeBeacon = newUserState.nearest_beacon_id !== oldUserState.nearest_beacon_id
  const isChangeCard = newUserState.nearest_card_id !== oldUserState.nearest_card_id

  if (isInSameFloor && (isChangeBeacon || isChangeCard)) {
    return true
  }

  return false
}

const isChangedFloor = (newUserState: UserModel, oldUserState: UserModel) => {
  const isInDiffentFloor = newUserState.current_floor_id !== oldUserState.current_floor_id
  const isOutside = newUserState.is_outside !== oldUserState.is_outside

  if (isOutside || isInDiffentFloor) {
    return true
  }

  return false
}
